import auth from './auth'
import abilities from './abilities'

export default router => {
  router.beforeEach(auth)
  router.beforeEach(abilities)
}
